import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { navigateToExternalLink } from '@deltek/specification-client/core/Utilities/urlUtils'
import Link from '@material-ui/core/Link'
import { makeStyles, Theme } from '@material-ui/core/styles'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    tableBorder: {
        '& .MuiTableCell-sizeSmall:last-child': {
            paddingLeft: 0,
            paddingTop: theme.spacing(1.25),
            paddingBottom: theme.spacing(1.25),
        },
    },
    itemLink: {
        maxWidth: 470,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            cursor: 'pointer',
        },
        fontSize: pxToRem(14),
        color: '#A78966',
    },
}))

interface LinkTableRowProps {
    name: string
    url: string
}

export const LinkTableRow: React.FC<LinkTableRowProps> = ({ name, url }) => {
    const classes = useStyles()

    return (
        <TableRow className={classes.tableBorder}>
            <TableCell component="th" scope="row">
                <Link
                    data-testid="navigationLink"
                    onClick={() => navigateToExternalLink(url)}
                >
                    <Typography variant="body1" className={classes.itemLink}>
                        {name}
                    </Typography>
                </Link>
            </TableCell>
        </TableRow>
    )
}
